import {AxiosError} from 'axios';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';

import {getPersianErrorCode} from '../../../global/helpers/ErrorCodes/ErrorCode';
import {ErrorResponse} from '../patchDirectLoanRequest/usePatchDirectLoanRequest';
import {deleteLoanRequest} from './deleteLoanRequest';

const useDeleteLoanRequest = () => {
  const queryClient = useQueryClient();
  const {mutate, isLoading} = useMutation({
    mutationFn: (loanGuid: string) => deleteLoanRequest(loanGuid),

    onError: (error: AxiosError<ErrorResponse>) => {
      const errorCode = error.response?.data?.error_code;

      if (errorCode) {
        toast.error(getPersianErrorCode(errorCode));

        return;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('get-list-loan-request');
      queryClient.invalidateQueries('list-taken-loan');
    },
  });

  return {mutate, isLoading};
};

export default useDeleteLoanRequest;
